import React from 'react';
import utils from '@utils';

export const JobHistoryColumns = (timeZoneId, getIndex) => [
	{
		property : 'DateChange',
		header   : {
			label : 'Modification Date',
		},
		headerClass : 'col-sm-3 bordered',
		cell        : {
			formatters : [
				(value) => (
					<span>{ utils.parseUTCDateToTimeZone(value, timeZoneId).format('MM/DD/YYYY hh:mm A') }</span>
				),
			],
		},
	},
	{
		property : 'User',
		header   : {
			label : 'Changed By',
		},
		headerClass : 'col-sm-3 bordered',
		cell        : {
			formatters : [
				(user) => (
					<span>
						{' '}
						{ user ? user.FullName : '' }
						{' '}
					</span>
				),
			],
		},
	},
	{
		property : 'Action',
		header   : {
			label : 'Action',
		},
		headerClass : 'col-sm-2 bordered',
		cell        : (value) => ({
			value,
			props : {
				className : 'bordered',
			},
		}),

	},
	{
		property : 'Model',
		header   : {
			label : 'Changes In',
		},
		headerClass : 'col-sm-2 bordered',
		cell        : (value) => ({
			value,
			props : {
				className : 'bordered',
			},
		}),

	},
	{
		property : '',
		header   : {
			label : 'Details',
		},
		headerClass : 'col-sm-2 bordered',
		cell        : {
			formatters : [
				(value, { rowData, rowIndex }) => {
					const { Action } = rowData;
					if (Action === 'Modified') {
						return (
							<button
								className="btn btn-link"
								type="button"
								onKeyPress={null}
								tabIndex={0}
								onClick={getIndex(rowIndex)}
							>
								View
							</button>
						);
					}

					return '';
				},
			],
		},
	},
];

export const JobHistoryDetailColumns = (timeZoneId) => [
	{
		property : 'PropertyName',
		header   : {
			label : 'Property Name',
		},
		headerClass : 'col-sm-4 bordered',
		cell        : (value) => ({
			value,
			props : {
				className : 'bordered',
			},
		}),

	},
	{
		property : 'PreviousValue',
		header   : {
			label : 'Previous Value',
		},
		headerClass : 'col-sm-4 bordered',
		cell        : {
			formatters : [
				(value, { rowData }) => {
					const { PropertyName } = rowData;
					if (PropertyName.includes('Date') || PropertyName.includes('Time')) {
						return (
							<span>
								{ utils.parseUTCDateToTimeZone(value, timeZoneId).format('MM/DD/YYYY hh:mm:ss A') }
							</span>
						);
					}

					return (value || 'Not Set');
				},
			],
			props : {
				className : 'bordered',
			},
		},

	},
	{
		property : 'CurrentValue',
		header   : {
			label : 'Current Value',
		},
		headerClass : 'col-sm-4 bordered',
		cell        : {
			formatters : [
				(value, { rowData }) => {
					const { PropertyName } = rowData;

					if (PropertyName.includes('Date') || PropertyName.includes('Time')) {
						return (
							<span>
								{ utils.parseUTCDateToTimeZone(value, timeZoneId).format('MM/DD/YYYY hh:mm:ss A') }
							</span>
						);
					}

					return (value || 'Not Set');
				},
			],
			props : {
				className : 'bordered',
			},
		},
	},
];

export default {
	JobHistoryColumns,
	JobHistoryDetailColumns,
};
